const ASCII_ZERO = 48;
const ASCII_NINE = 57;

function getCharCode(event) {
  return event.which ? event.which : event.keyCode;
}

export function onlyDigits(event) {
  const charCode = getCharCode(event);

  if (charCode > 31 && (charCode < ASCII_ZERO || charCode > ASCII_NINE)) {
    return false;
  }
  return true;
}

export function trimLeadingZero(event) {
  event.target.value = event.target.value.replace(/^0/, '');
}

export function createCookie(name, value, days) {
  let expires;
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires= ${date.toGMTString()}`;
  } else {
    expires = '';
  }
  document.cookie = `${name}=${value}${expires}; path=/`;
}

export function getFromQuery(name) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(name);
}
